var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TableView',{attrs:{"col":_vm.columns,"getData":_vm.getData}})
}
var staticRenderFns = []

export { render, staticRenderFns }